import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Area } from '../../../core/constants/area';
import { finalize } from 'rxjs/operators/finalize';
import { ConsoleLogger } from '../../../core/utilities/console-logger';
import { LocalStorageKeys } from '../../../core/constants/localStorageKeys.enum';

@Component({
  selector: 'app-website-info',
  templateUrl: './website-info.component.html',
  styleUrls: ['./website-info.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WebsiteInfoComponent implements OnInit{

    webApiIpAddress = '';
    isLoadingIpAddress = false;

    consoleInfoLogsEnabled = false;
	consoleInfoLogsIncludeTrace = false;
	showAccessTokenExpiration = false;
	showRequestQueueTestToggle = false;

    constructor(
        private http: HttpClient
    ){}

    ngOnInit() {    
        this.initializeAccessTokenExpirationTimer(); 
        this.initializeConsoleLogger(); 
        this.initializeShowRequestQueueTestToggle(); 
        this.getWebApiIpAddress();  
    }

	initializeAccessTokenExpirationTimer() {
		const accessTokenExpirationLsValue = localStorage.getItem(
			LocalStorageKeys.SHOW_ACCESS_TOKEN_EXPIRATION
		);

		if (accessTokenExpirationLsValue) {
			this.showAccessTokenExpiration = accessTokenExpirationLsValue === 'true';
		}
	}

    initializeConsoleLogger() {
        const infoEnabledLsValue = localStorage.getItem(
            LocalStorageKeys.CONSOLE_LOG_INFO_ENABLED
        );
        const includeTraceLsValue = localStorage.getItem(
            LocalStorageKeys.CONSOLE_LOG_INCLUDE_TRACE
        );
    
        if (infoEnabledLsValue) {
            this.consoleInfoLogsEnabled = infoEnabledLsValue === 'true';
        }
        if (includeTraceLsValue) {
            this.consoleInfoLogsIncludeTrace = includeTraceLsValue === 'true';
        }
    }

    initializeShowRequestQueueTestToggle() {
		const showRequestQueueTestToggleLsValue = localStorage.getItem(
			LocalStorageKeys.SHOW_REQUEST_QUEUE_TEST_TOGGLE
		);

		if (showRequestQueueTestToggleLsValue) {
			this.showRequestQueueTestToggle =
				showRequestQueueTestToggleLsValue === 'true';
		}
	}

    getWebApiIpAddress() {
        this.isLoadingIpAddress = true;
        this.http
            .get(`${environment.dotNetApiUrl}/${Area.test}/ipAddress`, {
                responseType: 'text',
            })
            .pipe(finalize(() => (this.isLoadingIpAddress = false)))
            .subscribe((res) => {
                this.webApiIpAddress = res;
            });
    }

    triggerBadRequest() {
        this.http
            .get<any>(
                `${environment.dotNetApiUrl}/${Area.test}/testErrors/badRequest`
            )
            .subscribe((x) => ConsoleLogger.logInfo(x));
    }
    
    triggerUnauthorized() {
	    this.http
		    .get<any>(
			    `${environment.dotNetApiUrl}/${Area.test}/testErrors/unauthorized`
		    )
		    .subscribe((x) => ConsoleLogger.logInfo(x));
	}

    triggerForbidden() {
		this.http
			.get<any>(`${environment.dotNetApiUrl}/${Area.test}/testErrors/forbidden`)
			.subscribe((x) => ConsoleLogger.logInfo(x));
	}

    triggerInternalServerError() {
		this.http
			.get<any>(
				`${environment.dotNetApiUrl}/${Area.test}/testErrors/internalServerError`
			)
			.subscribe((x) => ConsoleLogger.logInfo(x));
	}

    updateConsoleLogging() {
		if (this.consoleInfoLogsEnabled) {
			localStorage.setItem(LocalStorageKeys.CONSOLE_LOG_INFO_ENABLED, 'true');
		} else {
			localStorage.removeItem(LocalStorageKeys.CONSOLE_LOG_INFO_ENABLED);
		}
		if (this.consoleInfoLogsIncludeTrace) {
			localStorage.setItem(LocalStorageKeys.CONSOLE_LOG_INCLUDE_TRACE, 'true');
		} else {
			localStorage.removeItem(LocalStorageKeys.CONSOLE_LOG_INCLUDE_TRACE);
		}
	}

    updateSessionCountdowns() {
		if (this.showAccessTokenExpiration) {
			localStorage.setItem(
				LocalStorageKeys.SHOW_ACCESS_TOKEN_EXPIRATION,
				'true'
			);
		} else {
			localStorage.removeItem(LocalStorageKeys.SHOW_ACCESS_TOKEN_EXPIRATION);
		}
	}

    updateShowRequestQueueTestToggle() {
		if (this.showRequestQueueTestToggle) {
			localStorage.setItem(
				LocalStorageKeys.SHOW_REQUEST_QUEUE_TEST_TOGGLE,
				'true'
			);
		} else {
			localStorage.removeItem(LocalStorageKeys.SHOW_REQUEST_QUEUE_TEST_TOGGLE);
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/developer/system-settings/website-info/website-info.component.ts